module.exports = __webpack_public_path__ + "img/0090.b6c70c3f.png";